import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useMetaTags = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const updateMetaTags = async () => {
      try {
        // Get the current language
        const currentLang = i18n.language;
        
        // Load the language file to get meta data
        const response = await fetch(`/i18n/${currentLang}.json`);
        const data = await response.json();
        
        if (data.meta) {
          // Update or create title tag
          let titleTag = document.querySelector('title');
          if (titleTag) {
            titleTag.textContent = data.meta.title;
          }
          
          // Update or create meta description tag
          let descriptionTag = document.querySelector('meta[name="description"]');
          if (descriptionTag) {
            descriptionTag.setAttribute('content', data.meta.description);
          } else {
            descriptionTag = document.createElement('meta');
            descriptionTag.name = 'description';
            descriptionTag.content = data.meta.description;
            document.head.appendChild(descriptionTag);
          }
          
          // Update html lang attribute
          document.documentElement.lang = currentLang;
        }
      } catch (error) {
        console.error('Error updating meta tags:', error);
      }
    };

    updateMetaTags();
  }, [i18n.language]);
};
